module.exports = __webpack_public_path__ + "img/agriculture/square_icon5.759cbeff.png";